export const formatVersion = (data: any): Object => ({
  platform: data.get('platform'),
  version: data.get('productionVersion'),
});
